export const observeImageLookahead = (): (() => void) => {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        const image = entry.target as HTMLImageElement
        observer.unobserve(image)
        image.loading = "eager"
        void image.decode().catch(() => undefined)
      }
    },
    { rootMargin: `${window.innerHeight * 2}px ${window.innerWidth}px` }
  )
  const visitImages = (root: Node, visit: (image: HTMLImageElement) => void) => {
    if (!(root instanceof Element)) return
    if (root instanceof HTMLImageElement) visit(root)
    for (const image of root.querySelectorAll<HTMLImageElement>("img")) visit(image)
  }
  const observe = (image: HTMLImageElement) => {
    if (image.isConnected && image.loading === "lazy") observer.observe(image)
  }
  visitImages(document.body, observe)
  const mutations = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.removedNodes) visitImages(node, (image) => observer.unobserve(image))
      for (const node of record.addedNodes) visitImages(node, observe)
    }
  })
  mutations.observe(document.body, { childList: true, subtree: true })
  return () => {
    observer.disconnect()
    mutations.disconnect()
  }
}
